import i18n, { currentLanguage } from './index';

// Dates in the chosen language. English hands the browser `undefined`, exactly as every call
// site did before translation existed, so an English user's dates do not move. Numbers have no
// helper on purpose: they keep a full-stop decimal in every language (see index.js).
export const formatDateTime = (value) => new Date(value).toLocaleString(currentLanguage().dateLocale);

export const formatDate = (value) => new Date(value).toLocaleDateString(currentLanguage().dateLocale);

export const formatTime = (value) => new Date(value).toLocaleTimeString(currentLanguage().dateLocale);

const INTERVALS = [
    ['year', 31536000], ['month', 2592000], ['day', 86400], ['hour', 3600], ['minute', 60], ['second', 1]
];

// "3 days ago" in the chosen language. It takes the language's tag rather than dateLocale: this
// is a sentence, not a date format, so an English page on a German browser still reads English.
// Intl's English output is word for word what the hand-rolled version produced.
export const formatTimeAgo = (value) => {
    const seconds = Math.floor((Date.now() - new Date(value)) / 1000);
    const interval = INTERVALS.find(([, length]) => seconds >= length);
    if (!interval) return i18n.t('account.justNow');
    const [unit, length] = interval;
    return new Intl.RelativeTimeFormat(currentLanguage().tag).format(-Math.floor(seconds / length), unit);
};

// Month abbreviated and no seconds, the compact form the list pages use. Null for a missing or
// unreadable date, so a caller can show a dash rather than "Invalid Date".
export const formatDateTimeShort = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date.toLocaleString(currentLanguage().dateLocale, {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
};
